import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { MdAdd, MdSettings } from "react-icons/md";
import { Title } from "../../components/Title";
import {
  MedicalConcernCategoryForm,
  ICreateMedicalConcernCategoryValues,
} from "../../forms";
import {
  MedicalConcernCategoriesDocument,
  MedicalConcernCategory,
  useMedicalConcernCategoriesQuery,
  useCreateMedicalConcernCategoryMutation,
  useDeleteMedicalConcernCategoryMutation,
  useUpdateMedicalConcernCategoryMutation,
} from "../../graphql";

const MedicalConcernCategories: React.FC = () => {
  const [currentItem, setCurrentItem] = useState<MedicalConcernCategory>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data, loading } = useMedicalConcernCategoriesQuery();
  const [create] = useCreateMedicalConcernCategoryMutation();
  const [update] = useUpdateMedicalConcernCategoryMutation();
  const [deleteItem] = useDeleteMedicalConcernCategoryMutation();

  const handleCreatEvent = async (
    data: ICreateMedicalConcernCategoryValues
  ) => {
    currentItem
      ? await update({
          variables: {
            id: currentItem.id,
            name: data.name,
          },
          refetchQueries: [
            {
              query: MedicalConcernCategoriesDocument,
            },
          ],
        })
      : await create({
          variables: {
            name: data.name,
          },
          refetchQueries: [
            {
              query: MedicalConcernCategoriesDocument,
            },
          ],
        });

    onClose();

    setCurrentItem(null);
  };

  const handleDeleteEvent = async (id: number) => {
    await deleteItem({
      variables: {
        id: id,
      },
      refetchQueries: [
        {
          query: MedicalConcernCategoriesDocument,
        },
      ],
    });

    onClose();
  };

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={onClose}
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Shto një kategori</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <MedicalConcernCategoryForm
              onSubmit={(data) => handleCreatEvent(data)}
              initialValues={{
                name: currentItem?.rawName
                  ? currentItem.rawName
                  : { sq: "", en: "", mk: "" },
              }}
            />
          </ModalBody>
        </ModalContent>
      </Modal>
      <Box borderWidth="1px" borderRadius="lg" background="#FFF" p="10px">
        <Title title="Lista e simptomave">
          <Button
            rightIcon={<MdAdd />}
            colorScheme="blue"
            variant="outline"
            size="sm"
            onClick={onOpen}
          >
            Shto
          </Button>
        </Title>

        <Table variant="striped" size="sm">
          <Thead>
            <Tr>
              <Th>Simptoma</Th>
              <Th isNumeric></Th>
            </Tr>
          </Thead>
          <Tbody>
            {data?.medicalConcernCategories?.map((item) => (
              <Tr key={item.id}>
                <Td>{item.name}</Td>
                <Td isNumeric>
                  <Menu>
                    <MenuButton
                      px={2}
                      py={0.5}
                      transition="all 0.2s"
                      _focus={{ boxShadow: "outline" }}
                    >
                      <MdSettings />
                    </MenuButton>
                    <MenuList>
                      <MenuItem
                        onClick={() => {
                          setCurrentItem(item);
                          onOpen();
                        }}
                      >
                        Redakto
                      </MenuItem>
                      <MenuItem onClick={() => handleDeleteEvent(item.id)}>
                        Fshi
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </>
  );
};

export default MedicalConcernCategories;
